module.exports = __webpack_public_path__ + "img/partner16.dfb74ff7.png";